import * as yup from "yup";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState, useEffect } from "react";
import { FaCircleNotch } from "react-icons/fa";
import { IoSaveOutline } from "react-icons/io5";

import Datepicker from "../../../components/common/Datepicker";
import Toaster from "./../../../components/common/Toaster";

import complianceService from "./../../../services/complianceService";
import moment from "moment";

const schema = yup.object({
  end_date: yup.string().required("Please select deadline."),
});

const CorDeadlineForm = ({ deadline, isLoading, setLoading, onSuccess }) => {
  const [deadlineDate, setDeadlineDate] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (info) => {
    try {
      setLoading(true);

      const cor_deadline = { ...info };
      cor_deadline["id"] = deadline.id;

      await complianceService.saveCORDeadlineAsync(cor_deadline);

      setLoading(false);
      Toaster.Success("Deadline Saved Successfully.");
      onSuccess(cor_deadline);
    } catch (ex) {
      Toaster.Error("Something went wrong.");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (deadline) {
      const formatted_date = moment(deadline.end_date).format("MM-DD-yyyy");
      setValue("end_date", formatted_date);
      setDeadlineDate(formatted_date);
    }
  }, [deadline, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <Datepicker
            id="end-date-datepicker"
            name="end_date"
            title="Deadline"
            placeholder="MM-DD-YYYY"
            dateFormat="MM-DD-yyyy"
            setValue={setValue}
            clearErrors={clearErrors}
            register={register("end_date")}
            timeFormat={false}
            onDateChange={(date) => setDeadlineDate(date)}
            errors={errors}
            value={deadlineDate}
            readOnly
          />
        </div>
      </div>
      <div className="grid grid-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSaveOutline className="mr-3" />}
            Save Changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default CorDeadlineForm;
